import apiFetch from '@wordpress/api-fetch';

// wp/v2 or strakture/v1 (for external API calls)
const API_NAMESPACE_RE = /^(?:\/)?(?:wp|strakture)\/v\d+(?:\/|$|\?)/i;
apiFetch.use((options, next) => {
	if (!API_NAMESPACE_RE.test(options.path)) {
		return next(options);
	}

	return next({
		...options,
		headers: { ...options?.headers, 'X-Strakture': 'true' },
	});
});
